const storageTotallyBlocked = (): boolean => {
    try {
        localStorage.setItem('__t', '1'); localStorage.removeItem('__t');
        sessionStorage.setItem('__t', '1'); sessionStorage.removeItem('__t');
    } catch { return true; }
    try {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const req = indexedDB.open('__t'); req.onerror = () => {};
    } catch { return true; }
    return false;
};

export default storageTotallyBlocked;
